
const apiAddress = 'https://hms-api-fpcmh0csfdb4f0f6.eastus2-01.azurewebsites.net/';
//const apiAddress = 'http://localhost:59231/';

const baseUrl = apiAddress + 'api/';

const AppSettings = {
    apiRoutes: {
        hubUrl: apiAddress + 'ConnectionHub',
        login: baseUrl + 'identity/login',
        registerDoctor: baseUrl + 'identity/registerdoctor',
        registerPatient: baseUrl + 'identity/registerpatient',
        changePassword: baseUrl + 'identity/changepassword',
        validateToken: baseUrl + 'identity/validatetoken',

        getfiltered: baseUrl + 'doctor/getfiltered',
        getAppoinments: baseUrl + 'doctor/appoinments/',
        getDashboardCount: baseUrl + 'doctor/getcounts/',
        getPatients: baseUrl + 'doctor/getpatients/',
        deleteSchedule: baseUrl + 'doctor/deletescheduletime',
        upsertScheduleTime: baseUrl + 'doctor/upsertscheduletime',
        getScheduleTimes: baseUrl + 'doctor/getscheduletimes/',
        getFutureAppoinments: baseUrl + 'doctor/futureappoinments/',
        getScheduleTiming: baseUrl + 'doctor/getscheduletimes/',
        getVisitingCharges: baseUrl + 'doctor/visitingcharges/',
        getDoctorProfile: baseUrl + 'doctor/getprofile/',
        getinvoices: baseUrl + 'doctor/getinvoices/',
        UpdateDoctor: baseUrl + 'doctor/update',

        UpdatePatient: baseUrl + 'patient/Update',
        getAppoinmentsByPatient: baseUrl + 'patient/appoinments/',
        getPatient: baseUrl + 'patient/get/',

        createAppoinment: baseUrl + 'appoinment/create',
        getAppoinmentById: baseUrl + 'appoinment/get/',
        GetPrescriptionsByPatientId: baseUrl + 'appoinment/getprescriptions/',
        GetMedicalRecordsByPatientId: baseUrl + 'appoinment/getmedicalrecords/',
        getInvoicesByPatientId: baseUrl + 'appoinment/getinvoices/',
        addMedicalRecord: baseUrl + 'appoinment/addmedicalrecord',
        getPrescription: baseUrl + 'appoinment/getprescription',
        getPrescriptionById: baseUrl + 'appoinment/getprescriptionbyid/',
        addPrescription: baseUrl + 'appoinment/addprescription',
        updatePrescription: baseUrl + 'appoinment/updateprescription',
        ToggleAppoinment: baseUrl + 'appoinment/toggle',
        LoadPrescription: baseUrl + 'appoinment/loadprescription/',
      
        getInvoiceById: baseUrl + 'invoice/get/',
        createInvoice: baseUrl + 'invoice/create',
        updateInvoice: baseUrl + 'invoice/update',

        createReview: baseUrl + 'review/create',
        loadReviews: baseUrl + 'review/loadreviews/',
        submitReply: baseUrl + 'review/submitreply',
        submitRecommand: baseUrl + 'review/submitrecommand',

        GetMessageCount: baseUrl + 'message/count/',
        GetMessages: baseUrl + 'message/messages/',
        MarkMessagesAsRead: baseUrl + 'message/markasread',

        GetAllInventory: baseUrl + 'inventory/getall',
        GetAllService: baseUrl + 'service/getall',

        LoadSetting: baseUrl + 'setting/load',
    }
}

module.exports = AppSettings;